import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import './ContactSection.css';

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="contact-section section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Our Office Locations</h2>
          <p className="section-subtitle">
            Visit us at any of our convenient locations across Karnataka.
          </p>
        </motion.div>

        <div className="contact-content">
          <motion.div
            className="office-locations"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="office-list">
              <motion.div
                className="office-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                viewport={{ once: true }}
              >
                       <h5>Corporate Office</h5>
                <div className="address-block">
                  <div className="address-line"><MapPin size={16} /> 2nd floor HB Complex</div>
                  <div className="address-line-indent">Beside Rajkamal Stay In</div>
                  <div className="address-line-indent">Goshala Road Arab Mohalla</div>
                  <div className="address-line-indent">Raichur - 584101</div>
                </div>
              </motion.div>
              
              <motion.div
                className="office-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h5>Branch Office</h5>
                <div className="address-block">
                  <div className="address-line"><MapPin size={16} /> 2nd floor Opp no 2 bus Depo</div>
                  <div className="address-line-indent">Vidya Nagar S.B College Road</div>
                  <div className="address-line-indent">Kalaburagi - 585102</div>
                </div>
              </motion.div>
              
              <motion.div
                className="office-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <h5>Branch Office</h5>
                <div className="address-block">
                  <div className="address-line"><MapPin size={16} /> 2nd floor Opp Ganesh Nursing Home</div>
                  <div className="address-line-indent">P& T Colony</div>
                  <div className="address-line-indent">Kalaburagi - 585102</div>
                </div>
              </motion.div>
              
              <motion.div
                className="office-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <h5>Branch Office</h5>
                <div className="address-block">
                  <div className="address-line"><MapPin size={16} /> 1st floor Opp Bharath Gas Agency</div>
                  <div className="address-line-indent">Adarsh Nagar</div>
                  <div className="address-line-indent">Kalaburagi - 585103</div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
